import api from '@/apis/tax/tACircularVATDeclarationDirectAPI.js';
import Crud from '@/stores/crudBase';

var crud = new Crud('tACircularVATDeclarationDirect', api);

const state = {
  ...crud.state,
  _config: {
    table: 'ta_circular_vat_declaration',
    field: {
      key: 'ta_circular_vat_declaration_id',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,

  /**
   * Lấy dữ liệu xuất khẩu báo cáo
   * @param {*} context
   * @param {*} payload
   * @returns
   * NHANH3 17.1.2023
   */
  async export(context, payload) {
    return await api.export(payload);
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
